import React, { useState } from "react";
import styled from "styled-components";
import { imageZoomEffect, TitleStyles } from "./ReusableStyles";
import { ProductsList } from "../source/productsList";
import { useNavigate } from "react-router-dom";

export default function Products() {
  const [navbarState, setNavbarState] = useState(false);
  const [navbarStateName, setNavbarStateName] = useState('home');
  const html = document.querySelector("html");
  html.addEventListener("click", () => setNavbarState(false));

  const navigate = useNavigate();

  const handleNavigation = (target) => {
    setNavbarStateName('products');
    navigate(target);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setNavbarState(false);
  };

  return (
    <Section id="products">
      <div className="title">
        <h1>
          <span className="learnYourWay">Learn your way</span>
        </h1>
        <span className="learnYourWay">
          Your learning journey should fit your lifestyle. Choose the training method that works best for you – from group classes and instructor-led courses, to self-paced training, hands-on sandbox environments, and more.
        </span>
      </div>

      <div className="products">
        {ProductsList.map((product) => (
          <div className="product" key={product.name}>
            <div className="image">
              <img src={product.image} alt={product.name} />
            </div>
            <div className="product-content">
              <h2>{product.name}</h2>
              <p>{product.desc}</p>
              <button onClick={() => handleNavigation(`/products/${product.id}`)}>Read More</button>
            </div>
          </div>
        ))}
      </div>

      {/* <div className="see-more-wrapper">
        <button
          className="seeMoreBtn"
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.1)';
            e.target.style.letterSpacing = '2px';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.letterSpacing = 'normal';
          }}
          onClick={() => handleNavigation("products")}
        >
          SEE MORE
        </button>
      </div> */}
    </Section>
  );
}

const Section = styled.section`
  ${TitleStyles};

  .products {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
    margin-top: 3rem;

    .product {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5rem;
      padding: 1rem;

      .image {
        width: 100%;
        max-height: 12rem;
        overflow: hidden;
        border-radius: 1rem;

        img {
          width: 100%;
          height: 12rem;
          object-fit: contain;
          border-radius: 1rem;
          ${imageZoomEffect};
        }
      }

      .product-content {
        text-align: center;

        h2 {
          color: #fc4958;
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }

        p {
          font-size: 1.1rem;
          line-height: 1.6rem;
          margin-bottom: 1rem;
          padding: 0 1rem;
        }

        button {
          border: none;
          padding: 0.8rem 3rem;
          font-size: 1.2rem;
          color: white;
          border-radius: 4rem;
          transition: 0.5s ease-in-out;
          cursor: pointer;
          //background: linear-gradient(to right, #fc4958, #e85d04);
          //background: linear-gradient(to right, #3c30f0, #040a45);
          background: #040a45;
          text-transform: uppercase;

          &:hover {
            //background: linear-gradient(to right, #040a45, #3c30f0);
            background: #3c30f0
          }
        }
      }
    }
  }

  .see-more-wrapper {
    max-width: 100%;
    margin-top: 2rem;
    display: flex;
    justify-content: center;

    .seeMoreBtn {
      color: black;
      background: transparent;
      border: none;
      padding: 1rem 4rem;
      font-size: 1.4rem;
      cursor: pointer;
      text-decoration: underline;
      transition: all 0.3s ease-in-out;
    }
  }

  @media screen and (max-width: 720px) {
    .products {
      grid-template-columns: 1fr;
    }
  }
`;
